import { useCallback } from 'react';

import { VideoCallUrlQuery } from '@dreryk/egabinet-video-call-frontend-api';
import { AppointmentId } from '@dreryk/egabinet-appointment-published-language-api';

import { Clipboard, ClipboardEventHandler } from '@dreryk/react-components';
import { performCqrsQueryGet } from '@dreryk/command-query-react-common';
import { TranslatableText } from '@dreryk/react-common';

type VideoConsultationUrlClipboardProps = {
   readonly appointmentId: number;
   readonly label?: TranslatableText;
};

export const VideoConsultationUrlClipboard = (props: VideoConsultationUrlClipboardProps): JSX.Element | null => {
   const handleCopy = useCallback<ClipboardEventHandler>(async () => {
      return performCqrsQueryGet<string>(() => {
         const query = new VideoCallUrlQuery();
         query.appointmentId = AppointmentId.of(props.appointmentId);
         return query;
      });
   }, [props.appointmentId]);

   return <Clipboard onCopy={handleCopy} label={props.label} />;
};
